var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{attrs:{"id":"book-upload-modal","title":"Upload Book","hide-footer":"","centered":"","size":"xl"}},[_c('GammaStepper',{ref:"step",attrs:{"steps":_vm.stepperItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }